<template>
	<v-expansion-panel>
		<v-expansion-panel-header
			:color="headerColor"
		>
			<slot name="header"></slot>
		</v-expansion-panel-header>
		<v-expansion-panel-content
			:color="contentColor"
		>
			<slot name="content"></slot>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
export default {
	props: {
		contentColor: String,
		headerColor: String,
	},
}
</script>
